<template>
    <article>
        <div class="con" id="articleMain">
            <div v-if='con.length == 0' v-html='bodydata' ></div>

            <template v-for="(item,i) in con">
                <template v-if="item.type == 'text'">
                    <p v-html="item.con"></p>
                </template>
                <template v-if="item.type == 'img'">
                    <div class="img-container" :class="item.mode" v-on:click="showImg(item,$event)"
                         :style="item.dataHeight? 'height:' + item.dataHeight : ''">
                        <transition name="fade">
                            <img class="imgs" :class="item.mode" v-show="item.mode === 'on'" :src="getImgSrc(item.src)"
                                 @load="imgLoaded(item)">
                        </transition>
                    </div>
                    <span class="tips" v-if="item.tips">{{item.tips}}</span>
                </template>
                <template v-if="item.type == 'gif'">
                    <div class="img-container" :class="item.mode" v-on:click="showGifImg(item,$event)"
                         :style="item.dataHeight? 'height:' + item.dataHeight : ''">
                        <transition name="fade">
                            <img class="data-gif-src" :class="item.mode" :src="getImgSrc(item.src)"
                                 v-show="item.mode === 'on' || item.mode === 'gifLoading' || item.mode === 'gif'"
                                 @load="gifLoaded(item)">
                        </transition>
                        <div class="media-loader" v-if="item.mode !=='gif'"></div>
                        <div class="media-holder" v-if="item.mode ==='on'"></div>
                        <div class="media-label" v-if="item.mode ==='on'"></div>
                    </div>
                    <span class="tips" v-if="item.tips">{{item.tips}}</span>
                </template>
                <template v-if="item.type == 'music'">
                    <div class="audio">
                        <audio preload="off" :src="getImgSrc(item.src)">&nbsp;</audio>
                        <div class="main playing">
                            <h3>{{item.title}}</h3>
                            <p>{{item.artist}}</p>
                            <a class="play" v-if="item.pause" v-on:click.stop="audioPlay(item,$event)"></a>
                            <a class="pause" v-else v-on:click.stop="audioPause(item)"></a>
                        </div>
                        <div class="progress"></div>
                    </div>
                </template>
                <template v-if="item.type == 'video'">
                    <!--播放区-->
                    <!-- <section class="video" v-if="item.mode === 'player'"> -->
                    <section class="video" v-if="checkMode(item)">
                        <video
                            :style="'background:url('+ getImgSrc(item.thumb) +') top center no-repeat rgba(0,0,0,0.7);background-size: cover;'"
                            :src="getImgSrc(item.src)" controls="controls" @play="videoPlay()"></video>
                    </section>

                    <template v-else>
                        <div class="mask"></div>
                        <div class="media-container media-container-video"
                             v-if="item.thumb" v-on:click="videoPlay(item.src)"
                             v-bind:style="{'backgroundImage':'url('+ getImgSrc(item.thumb) +')','height':video_height+'px'}">
                            <div class="media-holder media-holder-video"></div>
                        </div>
                        <div class="media-container media-container-video" v-else v-on:click="videoPlay(item.src)"
                             v-bind:style="{'height':video_height+'px'}"
                        >
                            <div class="media-holder media-holder-video"></div>
                        </div>

                        <span class="tips_v" v-if="item.tips">{{item.tips}}</span>
                    </template>
                </template>
                <template v-if="item.type == 'subtitle'">
                    <h2 v-if="item.tagName==='H2'"><span class="border"></span>{{item.con}}</h2>
                    <h3 v-else><span class="border"></span>{{item.con}}</h3>
                </template>
                <template v-if="item.type == 'votes'">
                    <div class='vote_box' v-show="item.ready">
                        <h4>
                            <span>Vote</span>
                        </h4>
                        <div v-bind:class="item.voteType">
                            <template v-if="!item.voted">
                                <dl>
                                    <dt>
                                        {{item.title}}
                                        <span>
                          <template v-if="item.voteType === 'checkbox'">
                            (allow {{item.max_vote}} options)
                          </template></span>
                                    </dt>
                                    <template v-for="(option,index) in item.options">
                                        <dd v-if="option.sel" class="checked" v-on:click="optionSel(option,index,item)">
                                            <span class="tag"></span>
                                            {{option.title}}
                                        </dd>
                                        <dd v-if="!option.sel" v-on:click="optionSel(option,index,item)">
                                            <span class="tag"></span>
                                            {{option.title}}
                                        </dd>
                                    </template>
                                </dl>
                                <div class="text">
                                    <a v-if='item.selCounter>0' class="btn" @click="optionSub(item)">Submit</a>
                                    <a v-else class="btn btn_dis">{{$t('submit')}}</a>
                                </div>
                            </template>
                            <template v-if="item.voted">
                                <dl class="re">
                                    <dt>
                                        {{item.title}}
                                        <span>
                          <template v-if="item.voteType === 'checkbox'">
                            (allow {{item.max_vote}} options)
                          </template>
                          </span>
                                    </dt>
                                    <template v-for="(option,index) in item.options">
                                        <dd>
                                            <h3>
                                                {{option.title}} <em v-if="option.voted">{{ $('voted') }}</em>
                                                <span>{{option.stat}}%</span>
                                            </h3>
                                            <div class="rank">
                                                <div class="bar" v-bind:class="option.voted? 'voted':''"
                                                     v-bind:style="{width:option.stat+'%'}"></div>
                                            </div>
                                        </dd>
                                    </template>
                                </dl>
                                <div class="text">
                                    <p v-if="item.selCounter > 0">{{ $('thanksVote') }}</p>
                                    <p v-else>{{ $('voteOver') }}</p>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </template>
        </div>

        <template>
            <div class="declare" v-if="!afhao || afhao.length === 0 || JSON.stringify(afhao) === '{}'">
                <p><a href="https://api.allfootballapp.com/about/copyright">Copyright Declaration</a></p>
            </div>
            <div class="afhaoBottom clearfix" v-else>
                <p class="afhaoAbout">
                    <a :href="afhao.intro_schema">
                        <img src="../assets/afhao_about.png">
                        <span>{{$t('AboutUserPosts')}}</span>
                    </a>
                </p>
                <p class="afhaoReport" @click="afhaoReport()">
                    <img src="../assets/alert.png" alt="">
                    <span>{{ $t('Report') }}</span>
                </p>
            </div>
        </template>
    </article>
</template>

<script>
    import Vue from 'vue';
    import axios from 'axios';

    export default {
        name: 'articleCon',
        data: function () {
            return {
                baseUrl: global.apiDomain,
                imgMode: 'loading',
                con: [],
                video_height: 0,
                UUID: '',
                voteObj: {},
                createDomData: function () {},
                voteId: ''
            };
        },
        props: ['bodydata', 'afhao'],
        computed: {
            subtitChoose () {
                if (this.$route.params.subtitle) {
                    return this.$route.params.subtitle;
                }
                if (this.$store.state.navStore && this.$store.state.navStore.subtitChoose) {
                    return this.$store.state.navStore.subtitChoose;
                }
                return 'Headline';
            }
        },

        mounted () {
            let that = this;

            this.createDomData = function (rawHtml) {
                let main = document.querySelector('#articleMain');
                let html = main.childNodes[0].childNodes;
                for (let i = 0; i < html.length; i++) {
                    let item = html[i];
                    let child = item.children || null;
                    let data = {
                        type: 'blank'
                    };
                    if (item.nodeType === 1) {
                        if (item.tagName === 'P') {
                            if (child.length) {
                                child = child[0];
                                if (child.tagName === 'IMG') {//图片
                                    let tips = '';
                                    if (child.nextElementSibling) {
                                        tips = child.nextElementSibling.innerText;
                                    }
                                    let _width = parseInt(child.getAttribute('data-width') || 0);
                                    let _height = parseInt(child.getAttribute('data-height') || 0);
                                    let height = _width && _height ? _height / _width * this.mainWidth : '';
                                    data = {
                                        type: 'img',
                                        dataSrc: child.getAttribute('data-src') || child.getAttribute('src'),
                                        origSrc: child.getAttribute('orig-src') || child.getAttribute('src'),
                                        dataHeight: height ? height + 'px' : '',
                                        mode: this.imgMode,
                                        src: '',
                                        tips: tips
                                    };
                                    if (child.className === 'data-gif-src') {//gif
                                        let tips = '';
                                        if (child.nextElementSibling) {
                                            tips = child.nextElementSibling.innerText;
                                        }
                                        data['type'] = 'gif';
                                        data['dataGifSrc'] = child.getAttribute('data-gif-src');
                                        data['mode'] = this.imgMode;
                                        data['showReal'] = false;
                                        data['loaded'] = false;
                                        data['tips'] = tips;
                                    }
                                } else if (child.tagName === 'AUDIO') {//音乐
                                    data = {
                                        type: 'music',
                                        'artist': child.getAttribute('artist'),
                                        'src': child.getAttribute('src'),
                                        'title': child.getAttribute('title'),
                                    };
                                } else {
                                    const reg = /allfootball:\/\/\/?news\/(\d+)/g;
                                    let con = item.innerHTML && item.innerHTML.toString();
                                    if (con) {
                                        con = con.replace(reg, '/news/' + this.getUrlTitle(this.subtitChoose) + '/' + this.getUrlTitle(child.innerText) + '/$1');
                                        con = con.replace(/allfootball:\/\/\/?[^'"]*/g, '/download');
                                    }

                                    data.type = 'text';
                                    data.con = con;
                                }
                            } else {
                                const reg = /allfootball:\/\/\/?news\/(\d+)/g;
                                let con = item.innerHTML && item.innerHTML.toString();
                                if (con) {
                                    con = con.replace(reg, '/news/' + this.getUrlTitle(this.subtitChoose) + '/$1');
                                    con = con.replace(/allfootball:\/\/\/?[^'"]*/g, '/download');
                                }

                                data.type = 'text';
                                data.con = con;
                            }
                        } else if (item.className === 'video') {//视频
                            let tips = '';
                            if (item.nextElementSibling.tagName === 'SPAN') {
                                tips = item.nextElementSibling.innerText;
                            }
                            data = {
                                type: 'video',
                                src: item.getAttribute('src'),
                                mode: item.getAttribute('mode'),
                                android_mode: item.getAttribute('android_mode'),
                                ios_mode: item.getAttribute('ios_mode'),
                                title: item.getAttribute('title'),
                                thumb: item.getAttribute('thumb'),
                                hash: item.getAttribute('hash'),
                                site: item.getAttribute('site'),
                                videoStyle: {},
                                tips: tips
                            };
                        } else if (item.className === 'vote') {//投票
                            data = {
                                type: 'votes',
                                id: item.getAttribute('rel'),
                                ready: false
                            };
                        } else if (item.tagName === 'H2' || item.tagName === 'H3') {//副标题
                            data = {
                                tagName: item.tagName,
                                type: 'subtitle',
                                con: item.innerText
                            };
                        }
                        this.con.push(data);
                    }
                }
            };

            this.createDomData();

            // 投票
            let vote_ids = [];
            for (let i = 0; i < this.con.length; i++) {
                let item = this.con[i];
                if (item.type === 'votes') {
                    vote_ids += item.id + '_';
                }
                if (item.type === 'music') {
                    Vue.set(item, 'pause', true);
                }
            }
            if (vote_ids.length > 0) {//获取投票模块列表信息
                var fingerJs = require('../lib/fingerprint.min.js');
                this.UUID = 'CA' + new fingerJs.Fingerprint({ canvas: true }).get();
                axios.get(that.baseUrl + '/m/poll?id=' + vote_ids, {
                    headers: {
                        UUID: this.UUID
                    }
                }).then((response) => {
                    let data = response.data;
                    for (let i = 0; i < that.con.length; i++) {
                        let item = that.con[i];
                        if (item.type === 'votes') {
                            let voteType = data[0].max_vote > 1 ? 'checkbox' : 'radio';
                            Vue.set(item, 'max_vote', data[0].max_vote);
                            Vue.set(item, 'voteType', voteType);
                            Vue.set(item, 'title', data[0].title);
                            Vue.set(item, 'voted', data[0].voted);
                            Vue.set(item, 'options', data[0].options);
                            Vue.set(item, 'ready', true);
                            Vue.set(item, 'selCounter', 0);
                            Vue.set(item, 'selList', []);
                            data.splice(0, 1);
                        }
                        if (!data.length) {
                            break;
                        }
                    }
                }, (response) => {
                    // error callback
                });
            }
            this.loadImages();
            this.mainWidth = (document.documentElement.clientWidth || window.screen.width);
            this.video_height = (this.mainWidth - 30) * 9 / 16 - 40;
        },
        methods: {
            //判断当前播放的类型是否是player
            checkMode (item) {
                window.browers = {};
                var ua = navigator.userAgent.toLowerCase();
                browers.Android = ua.match(/android/);
                browers.iOS = ua.match(/ipad|iphone|ios/);
                let mode = item.mode;
                let android_mode = item.android_mode;
                let ios_mode = item.ios_mode;
                if (mode == 'player') {return true;}
                if (browers.Android && android_mode == 'player') {return true;}
                if (browers.iOS && ios_mode == 'player') {return true;}
                return false;
            },
            loadImages: function () {
                let imagesItem = this.con.filter(function (x) {
                    if (x.type === 'img' || x.type === 'gif') {
                        return x;
                    }
                });
                for (let i = 0, len = imagesItem.length; i < len; i++) {
                    let item = imagesItem[i];
                    this.imgSrc(item, item.dataSrc);
                }
            },
            showImg: function (item) {
                if (item.mode === 'off') {
                    item.mode = 'loading';
                    this.imgSrc(item, item['dataSrc']);
                } else {
                    // this.imgView(item);
                }
            },
            showGifImg: function (item) {
                if (item.mode === 'off') {
                    item.mode = 'loading';
                    this.imgSrc(item, item['dataSrc']);
                } else if (item.mode === 'on') {
                    item.mode = 'gifLoading';
                    this.imgSrc(item, item['dataGifSrc']);
                } else {
                    // this.imgView(item);
                }
            },
            imgSrc: function (item, src) {
                if (src !== '') {
                    item.src = src;
                }
            },
            imgLoaded: function (item) {
                if (item.mode === 'loading') {
                    item.mode = 'on';
                }
            },
            gifLoaded: function (item) {
                if (item.mode === 'loading') {
                    item.mode = 'on';
                } else {
                    item.mode = 'gif';
                }
            },
            // getVoteId:function(){
            //     let voteBox = document.querySelectorAll('.vote_box');
            //     if(voteBox.length == 0){return}
            //     // let voteUrl = '/m/poll?id='
            //     let voteIds = voteBox[0].getAttribute("id").replace("vote_","") + "_"
            //     let voteUrl = '/m/poll?id=' + voteIds
            //     this.UUID = 'CA' ;
            //     axios.get(voteUrl, {
            //         headers: {
            //             UUID: this.UUID
            //         }
            //     }).then((response) => {
            //         let data = response.data;
            //         for (let i = 0; i < data.length; i++) {
            //             let item = data[i];
            //                 let voteType = data[0].max_vote > 1 ? 'checkbox' : 'radio';
            //                 // Vue.set(item, 'max_vote', data[0].max_vote);
            //             // if (item.type === 'votes') {
            //                 this.voteObj.type = "votes"
            //                 this.voteObj.max_vote = data[0].max_vote;
            //                 this.voteObj.voteType =voteType;
            //                 this.voteObj.title = data[0].title;
            //                 this.voteObj.voted = data[0].voted;
            //                 this.voteObj.options = data[0].options;
            //                 this.voteObj.ready = true;
            //                 // this.voteObj.selCounter = 0;
            //                 this.voteObj.selList = [];

            //                 data.splice(0, 1);
            //             // }
            //             if (!data.length) {
            //                 break
            //             }
            //         }
            //     }, (response) => {
            //         // error callback
            //     })
            // },
            optionSel: function (item, index, box) {
                let selList = box.selList;
                if (box.max_vote == 1) {

                    selList[0] = item.id;
                    box.options.forEach(function (item) {
                        Vue.set(item, 'sel', false);
                        Vue.set(item, 'voted', false);
                    });
                    Vue.set(item, 'voted', true);
                    Vue.set(item, 'sel', true);
                    Vue.set(box, 'selCounter', 1);
                    Vue.set(box, 'selList', selList);
                } else {
                    if (box.selCounter < box.max_vote) {
                        if (item.voted) {
                            selList.forEach(function (sel_id, i) {
                                if (sel_id === item.id) {
                                    selList.splice(i, 1);
                                }
                            });
                            Vue.set(item, 'sel', false);
                            Vue.set(box, 'selCounter', box.selCounter - 1);
                            Vue.set(box, 'selList', selList);
                            Vue.set(item, 'voted', false);

                        } else {
                            selList.push(item.id);
                            Vue.set(item, 'sel', true);
                            Vue.set(box, 'selCounter', box.selCounter + 1);
                            Vue.set(box, 'selList', selList);
                            Vue.set(item, 'voted', true);
                        }
                    }
                }
            },
            optionSub: function (item) {
                let that = this;
                let data = {
                    id: item.id,
                    list: item.selList
                };

                Vue.set(item, 'voted', true);
                axios.post(that.baseUrl + '/m/poll/commit', data, {
                    headers: {
                        UUID: this.UUID
                    }
                }).then((response) => {
                }, (error) => {
                });
            },
            audioPlay: function (item, event) {
                let musicBox = event.target.parentNode.parentNode;
                let music = musicBox.getElementsByTagName('audio')[0];
                let curPro = musicBox.getElementsByClassName('progress')[0];
                music.play();
                // Vue.set(item,'pause',false)
                item.pause = false;
                let musicPlay = window.setInterval(function () {
                    let cur = music.currentTime / music.duration * 100 + '%';
                    if (music.currentTime === music.duration) {
                        window.clearInterval('musicPlay');
                        item.pause = true;
                    }
                    curPro.style.width = cur;
                }, 1000);
            },
            audioPause: function (item) {
                let musicBox = event.target.parentNode.parentNode;
                let music = musicBox.getElementsByTagName('audio')[0];
                music.pause();
                window.clearInterval('musicPlay');
                item.pause = true;
            },
            videoPlay: function (url) {
                // 如果是分享文章页，跳下载
                const query = this.$route.query;
                if (query && query.type === 'share') {
                    let utilObj = require('@/util/util.js');
                    utilObj.jumpUrl();
                    return;
                }
                if (url) {
                    location.href = url;
                }
            },
            afhaoReport () {
                console.log('======');
                return false;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .main article {
        margin: 0 15px 15px 15px;
        font-size: 17px;
    }
    article .download{
        text-align: center;
        display: block;
        margin: 10px auto -20px;
        font-weight: bold;
        text-decoration: underline;
    }

    article p {
        line-height: 30px;
        margin: 22px 0;
        word-wrap: break-word;
    }

    article .con {
        margin-top: 20px;
    }

    article h2, article h3 {
        line-height: 1.5;
        font-weight: 600;
        margin: 10px 0;
        padding: 0 0 0 10px;
        position: relative;
        color: #333;
    }

    article h2 {
        font-size: 19px;
    }

    article h3 {
        font-size: 17px;
    }

    article h2 .border, article h3 .border {
        height: 6px;
        width: 6px;
        border-radius: 50%;
        display: block;
        position: absolute;
        top: 9px;
        left: 0;
        background: #16b13a;
    }

    article img {
        display: block;
        margin: 24px auto;
        /*max-width: 100%!important;*/
        width: 100%;
        background: #efefef no-repeat center center;
        background-size: 118px;
    }

    article img.data-gif-src {
        width: 100%
    }

    article video {
        display: block;
        width: 100%;
        margin: 0;
        background: #3e3e3e no-repeat center center;
        background-size: 118px;
        border-radius: 1px;
        -moz-border-radius: 1px;
        -webkit-border-radius: 1px;
    }

    article a {
        color: #399e5c;
    }

    .media-container {
        display: block;
        position: relative;
        z-index: 1000;
        margin: 0 auto;
    }

    .img-container {
        display: block;
        position: relative;
        z-index: 1000;
        margin: 20px auto 10px;
        min-height: 46px;
    }

    .img-container.off {
        background: url(../assets/img_holder_off.png) center center no-repeat #e9e9e9;
        background-size: auto 46px;
    }

    .img-container.off, .img-container.loading {
        height: 200px;
    }

    .img-container.loading {
        z-index: 1000;
        position: relative;
        background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;
        background-size: 20px 20px;
    }

    .media-loader {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;
        opacity: .3;
        -webkit-opacity: .3;
        -moz-opacity: .3;
        background-size: 20px 20px;
    }

    .media-holder {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url(../assets/play@80x80.png) no-repeat center center;
        background-size: 40px 40px;
    }

    .media-label {
        position: absolute;
        top: 0;
        left: 0;
        background: url(../assets/gif.png) 0 0 no-repeat;
        width: 33px;
        height: 33px;
        background-size: 100% 100%;
        text-indent: 1000px;
    }

    .media-loading {
        background: url(../assets/loading_circle.gif) #e9e9e9 no-repeat center center;
        filter: alpha(opacity=30);
        opacity: 0.3;
        background-size: 20px 20px;
    }

    .img-off-holder {
        width: 100%;
        height: auto;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
    }

    article .video {
        position: relative
    }

    article .video .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: url(../assets/icon_playing.png) center center no-repeat rgba(0, 0, 0, 0.5);
        background-size: auto 20px;
        z-index: 10000;
        display: none;
    }

    .media-container-video {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-color: rgba(0, 0, 0, 0.5);
        border-bottom: 20px solid #000000;
        border-top: 20px solid #000000;
        width: 100%;
        background-image: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_off_holder.png);
    }

    .media-holder-video {
        background: url(https://allfootball-static.dongqiudi.com/web-new/static/api/images/video_play.png) no-repeat center center;
        background-size: 48px auto;
    }

    .fade-enter-active {
        transition: opacity 1.5s
    }

    .fade-enter {
        opacity: 0
    }

    a.product_box:visited {
        color: #333333;
    }

    .audio {
        background-color: #ffffff;
        overflow: hidden;
        padding: 4px;
        position: relative;;
        margin: 24px auto;
        border: 1px solid #e9e9e9;
        height: 40px;
    }

    .audio a {
        width: 40px;
        height: 40px;
        float: right;
        margin-top: -43px;

    }

    .audio a.play {
        background: url(../assets/icon_play.png) center center no-repeat;
        background-size: 12px
    }

    .audio a.pause {
        background: url(../assets/icon_pause.png) center center no-repeat;
        background-size: 12px
    }

    .audio .main {
        padding-left: 50px;
        background: url(../assets/bg_music.png) 0 0 no-repeat;
        background-size: 40px 40px;
    }

    .audio .main h3 {
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        color: #2d2f32;
        font-weight: 400;
        margin: 0;
        padding: 0;
    }

    .audio .main p {
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        color: #8c9399;
        margin: 0;
        padding: 0;
    }

    .audio .progress {
        position: absolute;
        height: 2px;
        bottom: 0;
        left: 0;
        z-index: 100;
        background: #55c818;
    }

    .audio audio {
        position: absolute;
        display: none;
    }

    .vote_box {
        position: relative;
        border: 1px solid #eff1f4;
        margin: 50px 0 35px;
    }

    .vote_box h4 {
        position: absolute;
        top: -37px;
        width: 100%;
        line-height: 20px;
        height: 20px;
        left: 0;
        text-align: center
    }

    .vote_box span {
        display: inline-block;
        font-size: 16px;
        padding: 0 10px;
        background: #fff;
        color: #2d2f32;
    }

    .vote_box dl {
        margin: 0;
        padding: 0;
    }

    .vote_box dt {
        line-height: 20px;
        padding: 20px 0 12px 12px;
        font-size: 16px;
        color: #2d2f32;
        text-align: left;
    }

    .vote .radio dt span {
        fonts-size: 14px;
    }

    .vote_box dd {
        padding: 13px 10px 13px 40px;
        line-height: 24px;
        border-top: 1px solid #eff1f4;
        position: relative;
        font-size: 16px;
        color: #2d2f32;
    }

    .vote_box .re dd {
        padding: 10px;
    }

    .vote_box h3 {
        color: #5b6463;
        line-height: 20px;
        font-size: 14px;
        margin: 0 0 1px 0;
        padding: 0 26px 0 0;;
        position: relative;
        font-weight: 400;
    }

    .vote_box .re h3 {
        color: #2d2f32;
    }

    .vote_box h3 span {
        color: #2d2f32;
        position: absolute;
        bottom: 8px;
        right: 0;
        width: 26px;
        text-align: right;
        height: 14px;
        line-height: 14px;
        left: auto;
        top: auto;
    }

    .vote_box h3 em {
        color: #fff;
        background: #ff8d06;
        padding: 0 3px;
        border-radius: 2px;
        font-size: 10px;
        line-height: 16px;
        height: 16px;
        display: inline-block;
        -webkit-transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        -moz-transform: scale(.75, .75);
        -webkit-transform: scale(.75, .75);
        -o-transform: scale(.75, .75);
        transform: scale(.75, .75);
        font-style: normal;
        font-weight: normal;
    }

    .vote_box div.rank {
        width: 100%;
        height: 16px;
        line-height: 16px;
        background: #eff1f4;
    }

    .vote_box div.bar {
        background: #4ccf6c;
        height: 16px;
        line-height: 16px;
    }

    .vote_box div.voted {
        background: #ff8d06;
    }

    .vote_box dd span.tag {
        position: absolute;
        width: 12px;
        line-height: 20px;
        height: 12px;
        border: 1px solid #8dc99b;
        top: 18px;
        left: 15px;
        padding: 0;
    }

    .vote_box .checkbox span.tag {
        border-radius: 5px;
    }

    .vote_box .checkbox dd.checked span.tag {
        background: url(../assets/poll_check.png) center center no-repeat;
        border: 0;
        padding: 1px;
        border-radius: 0;
        background-size: 100% 100%
    }

    .vote_box .radio span.tag {
        border-radius: 20px;
    }

    .vote_box .radio dd.checked span.tag {
        background: url(../assets/check_r.png) center center no-repeat;
        border: 0;
        padding: 1px;
        border-radius: 0;
        background-size: 100% 100%
    }

    .vote_box .text {
        padding: 13px 0;
        text-align: center;
        line-height: 21px;
        border-top: 1px solid #ebebeb;
        font-size: 15px;
    }

    .vote_box .text p {
        text-align: center;
        margin: 0;
        font-size: 15px;
        color: #2d2f32;
    }

    .vote_box .text span {
        display: inline-block;
        max-width: 100px;
        height: 20px;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
    }

    .vote_box a.btn {
        display: block;
        width: 90px;
        background: #16b13a;
        margin: 0 auto;
        color: #fff;
        text-align: center;
        height: 35px;
        font-size: 15px;
        line-height: 35px;
        padding: 0;
        border-radius: 3px;
        text-decoration: none;

    }

    .tips {
        margin-top: -20px;
        display: block;
        width: 100%;
        font-size: 0.8em;
        color: #888888;
        line-height: 1.5
    }

    .tips_v {
        display: block;
        width: 100%;
        font-size: 0.8em;
        color: #8c9399;
        line-height: 1.5
    }

    .declare {
        margin: 0;
        padding: 0;
    }

    .declare {
        color: #808080;
        font-size: 14px;
        width: 100%;
        text-align: left;
    }

    .declare a {
        color: #91989d;
        font-size: 13px;
        margin: 10px 0;
        display: block;
    }

    .declare a:before {
        content: "";
        display: inline-block;
        background: url(../assets/copyright.png) center center no-repeat;
        background-size: 12px auto;
        width: 12px;
        margin-right: 4px;
        height: 15px;
        top: 2px;
        position: relative;
    }

    .afhaoBottom {
        margin: 0;
        height: auto;
    }

    .afhaoAbout {
        float: left;
        margin: 0px;
    }

    .afhaoAbout img {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        display: inline-block;
        min-height: 14px;
        background: none;
        margin-right: 2px;
        position: relative;
        top: 3px;
        margin: 0 6px 0 0;
    }

    .afhaoAbout span {
        font-size: 12px;
        color: #91989d;
    }

    .afhaoReport {
        float: right;
        margin: 0;
    }

    .afhaoReport img {
        display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        display: inline-block;
        min-height: 12px;
        background: none;
        margin-right: 2px;
        position: relative;
        top: 3px;
        margin: 0;
    }

    .afhaoReport span {
        font-size: 12px;
        color: #91989d;
    }
</style>



// WEBPACK FOOTER //
// articleCon.vue?0834462c